import { Account, AccountStatus } from "@/entities/account/model/types";
import { centsToDollars, dollarsToCents } from "@/shared/lib/format";
import { AccountOutputSchema } from "./accounts";

/**
 * Map API AccountOutputSchema to UI Account type
 */
export function mapAccountToUI(apiAccount: AccountOutputSchema): Account {
  const name = apiAccount.zip || `Account ${apiAccount.id.slice(0, 8)}`;
  const email = apiAccount.ssn ? `***-**-${apiAccount.ssn.slice(-4)}` : "N/A";

  return {
    id: apiAccount.id,
    externalId: apiAccount.id,
    name,
    email,
    ssn: apiAccount.ssn,
    dob: apiAccount.dob,
    zip: apiAccount.zip,
    phone: apiAccount.phone,
    creditLimit: centsToDollars(apiAccount.credit_limit),
    availableCredit: centsToDollars(apiAccount.available_credit),
    status: apiAccount.status as AccountStatus,
    location: apiAccount.locationName || apiAccount.location_id || "N/A",
    createdAt: apiAccount.createdAt || apiAccount.created_at || "",
  };
}

/**
 * Map UI Account to API AccountUpdateSchema (camelCase for PATCH requests)
 */
export function mapAccountToUpdate(account: Partial<Account>): {
  creditLimit?: number | null;
  availableCredit?: number | null;
  status?: "active" | "suspended" | null;
} {
  return {
    creditLimit: account.creditLimit !== undefined ? dollarsToCents(account.creditLimit) : null,
    availableCredit:
      account.availableCredit !== undefined ? dollarsToCents(account.availableCredit) : null,
    status: account.status ? (account.status as "active" | "suspended") : null,
  };
}
